import InsightsView from "./InsightsView/InsightsView";
import InsightsViewModal from "./InsightsViewModal/InsightsViewModal";

InsightsView.Modal = InsightsViewModal;

export default InsightsView;
